/** English — secondary language */
const en = {
  nav: {
    home: "Home",
    findJobs: "Find Jobs",
    companies: "Companies",
    postAJob: "Post a Job",
    signIn: "Sign In",
    getStarted: "Get Started",
    dashboard: "Dashboard",
    profile: "Profile",
    signOut: "Sign out",
    signedInAs: "Signed in as",
  },
  hero: {
    badge: "active jobs · companies hiring",
    h1a: "Find work",
    h1b: "near you",
    heroSubtitle: "Search opportunities by location, schedule, and work mode.",
    purposeLine: "InfoCityJobs connects candidates and companies: create your profile, prepare your CV, search for jobs, and apply to new opportunities.",
    subtitle: "Connecting top talent with leading companies across every industry.",
    searchJobs: "Search Jobs",
    keywordPlaceholder: "Job title, skills or company",
    locationPlaceholder: "City or remote",
    allTypes: "All Types",
    allLevels: "All Levels",
    popular: "Popular",
    jobsLabel: "Jobs",
    companiesLabel: "Companies",
    candidatesLabel: "Candidates",
    useMyLocation: "Use my location",
    forToday: "Today",
    urgentOnly: "Urgent",
    filtersBtn: "Filters",
    filterRemote: "Remote",
    filterPartTime: "Part-time",
    filterNoExperience: "No experience needed",
    categoriesLabel: "Categories",
    locating: "Locating...",
    viewJobsBtn: "View jobs",
  },
  sections: {
    featuredLabel: "Top Opportunities",
    featuredTitle: "Featured Jobs",
    recommendedForYouShort: "Recommended for you",
    completeProfileForRecs: "Complete your profile to improve your recommendations",
    jobCountSingular: "job",
    jobCountPlural: "jobs",
    featuredSubtitle: "Handpicked roles from top-tier employers",
    featuredViewAll: "View all",
    mapLabel: "Local Discovery",
    mapTitle: "Explore jobs on the map",
    mapSubtitle: "Discover what opportunities are available in your area.",
    noJobsYet: "No jobs available yet. Be the first to post one!",
    viewAllJobsBtn: "View all jobs",
    availableJobsLabel: "Recent jobs",
    availableJobsTitle: "Available jobs",
    companiesLabel: "Top Employers",
    companiesTitle: "Top Companies Hiring",
    companiesSubtitle: "Leading organizations actively looking for talent",
    companiesViewAll: "View all",
    marketLabel: "Market Data",
    marketTitle: "Job Market Intelligence",
    marketSubtitle: "Real-time salary benchmarks, hiring demand, and location trends.",
    employersLabel: "For Employers",
    employersTitle: "Are you hiring?",
    employersSubtitle: "Post jobs and reach thousands of qualified candidates. Hire faster, smarter, and more efficiently.",
    ecosystemLabel: "InfoCity Network",
    ecosystemTitle: "The InfoCity Ecosystem",
    ecosystemSubtitle: "One ecosystem. Six specialized marketplaces.",
    seeAllJobs: "See All Jobs",
  },
  market: {
    salaryTitle: "Avg. Salary by Sector",
    salarySubtitle: "Annual, USD",
    demandTitle: "Hiring Demand",
    demandSubtitle: "Current trends",
    citiesTitle: "Top Hiring Cities",
    citiesSubtitle: "Most active markets",
    openJobsLabel: "open jobs",
    remote: "Remote positions",
    fullTime: "Full-time roles",
    techSector: "Tech sector",
    entryLevel: "Entry level",
    seniorLevel: "Senior level",
  },
  employerFeatures: [
    "Post unlimited job listings",
    "Access to 125,000+ verified candidates",
    "Built-in applicant tracking (ATS)",
    "Hiring pipeline management",
    "Analytics and conversion reports",
    "AI-powered candidate matching",
  ],
  cta: {
    postJobFree: "Post a Job — It's Free",
    exploreCompanies: "Explore Companies",
    browseJobs: "Browse Jobs",
    seeAllJobs: "See All Jobs",
    youAreHere: "You are here",
    comingSoon: "Coming soon",
    exploreNearby: "Explore jobs near me",
    viewFullMap: "View full map",
    postJob: "Post a Job",
  },
  jobCard: {
    today: "Today",
    yesterday: "Yesterday",
    dAgo: "d ago",
    wAgo: "w ago",
    moAgo: "mo ago",
    applicants: "applicants",
    remote: "Remote",
    upTo: "Up to",
    perYear: "/yr",
    perHour: "/hr",
    perMonth: "/mo",
    hybrid: "Hybrid",
    match: "compatible",
    salaryNotSpecified: "Salary not specified",
    typeFullTime: "Full-time",
    typePartTime: "Part-time",
    typeContract: "Contract",
    typeTemporary: "Temporary",
    typeFreelance: "Freelance / Project-based",
    typeInternship: "Internship",
    typeHourly: "Hourly",
    typeSeasonal: "Seasonal",
    typeOther: "Other",
    expNoExperience: "No experience",
    expEntry: "Entry level",
    expJunior: "Junior",
    expMid: "Mid",
    expSenior: "Senior",
    expLead: "Lead",
    expManager: "Manager",
    expDirector: "Director",
    expExecutive: "Executive",
    expOther: "Other",
    shareAria: "Share job",
  },
  map: {
    searchThisArea: "Search this area",
    yourLocation: "Your current location",
    viewJob: "View job",
    noJobsInArea: "No jobs with location in this area",
    mapUnavailable: "Map unavailable right now",
    jobsAtLocation: "jobs at this spot",
  },
  jobsPage: {
    cityPlaceholder: "City...",
    listView: "List",
    mapView: "Map",
    radiusLabel: "Radius",
    nearMeBadge: "Near me",
    exitNearMe: "Exit",
    geoErrorBanner: "We couldn't get your location. Search manually by city.",
    dismiss: "Dismiss",
    jobsSuffix: "jobs",
    clear: "Clear",
    showAll: "Show all",
    showLess: "Show less",
    quickToday: "Today",
    quickUrgent: "Urgent",
    quickRemote: "Remote",
    quickPartTime: "Part-time",
    quickNoExp: "No exp.",
    backToAllJobs: "All jobs",
    quickFiltersLabel: "Quick filters",
    sectorLabel: "Sector",
    jobTypeLabel: "Job Type",
    workModeLabel: "Work Mode",
    experienceLabel: "Experience",
    datePostedLabel: "Date Posted",
    sortLabel: "Sort by",
    anyOption: "Any",
    anyTime: "Any time",
    salaryLabel: "Salary",
    salaryMinPlaceholder: "Min",
    salaryMaxPlaceholder: "Max",
    prevPage: "Previous",
    nextPage: "Next",
    dateToday: "Today",
    date3days: "Last 3 days",
    date7days: "Last week",
    date30days: "Last month",
    sortNewest: "Newest",
    sortSalary: "Highest salary",
    sortApplicants: "Most applicants",
    categoryTech: "Technology",
    categoryFinance: "Finance",
    categoryHospitality: "Hospitality",
    categoryHealthcare: "Healthcare",
    categoryMarketing: "Marketing",
    categoryEducation: "Education",
    categoryDesign: "Design",
    categoryLogistics: "Logistics",
    workModeRemote: "Remote",
    workModeHybrid: "Hybrid",
    workModeOnsite: "On-site",
    locationLabel: "Location",
    contractTypeLabel: "Contract Type",
    quickNearMe: "Near me",
    geoRequesting: "Locating...",
    geoErrorDenied: "Location permission denied. Search manually by city.",
    noJobsInRadiusTitle: "No jobs in this radius",
    noJobsInRadiusDesc: "We couldn't find jobs within {radius} km of your location. Try widening the radius.",
  },
  filters: {
    title: "Filters",
    clearAll: "Clear all",
    applyFilters: "Apply Filters",
    keyword: "Search jobs",
    location: "City or remote",
    category: "Category",
    jobType: "Job Type",
    experience: "Experience",
    workMode: "Work Mode",
    allCategories: "All Categories",
    allTypes: "All Types",
    allLevels: "All Levels",
    anyMode: "Any",
    remoteOnly: "Remote only",
    onsiteOnly: "On-site only",
    found: "jobs found",
    noJobs: "No jobs found",
    noJobsDesc: "Try adjusting your search terms or filters",
    clearFilters: "Clear filters",
    searching: "Searching...",
    search: "Search",
    remote: "Remote",
    jobListings: "Job Listings",
    findJobs: "Find Jobs",
  },
  jobDetail: {
    back: "Back to jobs",
    applyNow: "Apply Now",
    applyExternally: "Apply Externally",
    urgentBadge: "URGENT",
    todayBadge: "TODAY",
    immediateBadge: "IMMEDIATE START",
    remoteFromLabel: "Available from",
    shiftLabel: "Shift",
    alreadyApplied: "Applied",
    signInToApply: "Sign in to Apply",
    description: "Job Description",
    requirements: "Requirements",
    benefits: "Benefits",
    aboutRole: "About the Role",
    whatWeNeed: "What we need",
    perksLabel: "Perks & Benefits",
    interested: "Interested?",
    applyDesc: "Apply in 2 minutes. No account required to start.",
    jobDetails: "Job Details",
    companyLabel: "Company",
    jobTypeLabel: "Job Type",
    categoryLabel: "Category",
    experienceLabel: "Experience",
    locationLabel: "Location",
    postedLabel: "Posted",
    applicantsLabel: "Applicants",
    viewCompanyProfile: "View company profile",
    people: "people",
    jobClosedTitle: "This job is no longer accepting applications",
    jobClosedDesc: "The company closed or paused this listing.",
    shareAria: "Share job",
    reportJob: "Report job",
    reportTitle: "Report this job",
    reportReasons: {
      possible_fraud: "Possible fraud",
      false_info: "False information",
      discrimination: "Discrimination",
      inappropriate_content: "Inappropriate content",
      job_expired: "Expired job",
      other: "Other reason",
    },
    reportDetailsPlaceholder: "Tell us more (optional)",
    reportSubmit: "Send report",
    reportSent: "Thanks, we received your report. Our team will review it.",
    reportError: "We couldn't send the report. Please try again.",
    jobNotFound: "We couldn't find this listing",
    backToJobs: "Back to jobs",
    viewOfferExternal: "View offer / Apply on external site",
    descriptionPreview: "Job excerpt",
    descriptionPreviewCaption: "Summary provided by Adzuna. To see the full details, apply on the original site.",
    scheduleLabel: "Schedule",
    scheduleFullTime: "Full-time",
    schedulePartTime: "Part-time",
    contractPermanent: "Permanent contract",
    contractTemporary: "Temporary contract",
  },

  jobMatch: {
    cardTitle: "Compatibility with your CV",
    compatible: "compatible",
    basedOnCv: "Calculated from your real CV",
    viewAnalysis: "View analysis",
    noCvTitle: "Discover your compatibility",
    noCvDesc: "Create or upload your CV to see your compatibility with this job.",
    createCvCta: "Create my CV",
    modalTitle: "Compatibility analysis",
    matchesTitle: "Matches",
    gapsTitle: "Gaps",
    strengthsTitle: "Strengths",
    recoTitle: "Recommendations",
    strengthSkills: "You have {count} skills this job asks for",
    strengthExperience: "Your experience level is ideal for this role",
    strengthRemote: "This job's remote setup fully fits your profile",
    strengthLocation: "Your location matches this job's location",
    strengthAllReqs: "Your CV reflects every stated requirement",
    strengthRelevantExp: "Your experience as {position} is relevant for this role",
    recoKeywords: "If you truly have experience in {list}, consider adding it to your CV",
    recoRequirements: "This job asks for: \"{req}\" — check if your CV reflects it",
    recoExperience: "This job looks for a {level} profile; highlight in your CV whichever real experience gets closest to that level",
    recoHighlight: "Highlight your experience in {skill} since it's very relevant for this role",
    recoRelocate: "This job is on-site and doesn't match your location; mention your availability to relocate if it applies",
    strengthWorkMode: "Your preferred work mode matches this job's",
    recoWorkMode: "This job doesn't match your preferred work mode; review your preferences in your Professional Profile",
    strengthSalary: "This job's salary range covers your salary expectation",
    recoSalaryBelow: "This job's salary range is below your expectation; check if it still interests you",
    recoAvailability: "You haven't shared your availability; add it in your Professional Profile so companies can see it",
    recoLocationUnknown: "Location not evaluated due to missing information.",
    adaptCvCta: "Adapt my CV to this job",
    evaluatedNote: "Calculated over {max}/100 evaluable points based on this job's data",
    employer: {
      strengthSkills: "{name} has {count} skills this job asks for",
      strengthExperience: "{name}'s experience level is ideal for this role",
      strengthRemote: "This job's remote setup fully fits {name}'s profile",
      strengthLocation: "{name}'s location matches this job's location",
      strengthAllReqs: "{name}'s CV reflects every stated requirement",
      strengthRelevantExp: "{name}'s experience as {position} is relevant for this role",
      recoKeywords: "If {name} truly has experience in {list}, suggest adding it to their CV",
      recoRequirements: "This job asks for: \"{req}\" — check if {name}'s CV reflects it",
      recoExperience: "This job looks for a {level} profile; check if {name} highlights the closest real experience in their CV",
      recoHighlight: "{name} could highlight their experience in {skill} since it's very relevant for this role",
      recoRelocate: "This job is on-site and doesn't match {name}'s location; check their availability to relocate",
      strengthWorkMode: "{name}'s preferred work mode matches this job's",
      recoWorkMode: "This job doesn't match {name}'s preferred work mode",
      strengthSalary: "This job's salary range covers {name}'s salary expectation",
      recoSalaryBelow: "This job's salary range is below {name}'s expectation",
      recoAvailability: "{name} hasn't shared their availability in their Professional Profile",
      recoLocationUnknown: "Location not evaluated due to missing information.",
    },
  },
  cvAdapt: {
    modalTitle: "Adapt my CV to this job",
    generating: "Generating your tailored CV with AI...",
    errorMsg: "Couldn't generate the adaptation. Please try again in a moment.",
    close: "Close",
    forJob: "For the role of",
    summaryTitle: "Professional summary",
    original: "Original",
    adapted: "Adapted",
    skillsTitle: "Skills (reordered)",
    experienceTitle: "Experience (reordered)",
    suggestionsTitle: "Suggestions — not added to your CV",
    suggestionsHint: "This job mentions these skills. Only add them to your CV if you truly have experience with them.",
    versionNameLabel: "Name for this version",
    defaultVersionPrefix: "CV tailored for",
    discard: "Discard",
    saveVersion: "Save as new version",
    savedTitle: "Version saved!",
    downloadPdf: "Download PDF",
  },
  cvVersions: {
    title: "My CV Versions",
    empty: "You haven't tailored your CV for any job yet.",
    adaptedBadge: "Adapted",
    view: "View",
    downloadPdf: "Download PDF",
    delete: "Delete",
    deleteConfirm: "Delete this CV version?",
  },
  apply: {
    title: "Apply for Position",
    at: "at",
    fullName: "Full Name",
    email: "Email",
    phone: "Phone",
    linkedin: "LinkedIn (optional)",
    uploadCv: "Upload CV",
    uploadCvHint: "Click to upload PDF, DOC, DOCX",
    coverLetter: "Cover Letter",
    coverLetterPlaceholder: "Why are you a great fit for this role?",
    submit: "Submit Application",
    successTitle: "Application Submitted!",
    successMsg1: "Good luck! The team at",
    successMsg2: "will be in touch.",
    continue: "Continue Browsing",
    close: "Close",
    applyPosition: "Apply for Position",
  },
  companies: {
    header: "Companies",
    subtitle: "Find companies that are hiring.",
    searchPlaceholder: "Search companies...",
    cityPlaceholder: "City",
    allIndustries: "All industries",
    found: "company(ies) found",
    noResults: "No companies found",
    noResultsDesc: "Try a different search term",
    openRoles: "open role(s)",
    search: "Search",
    chipTech: "Technology",
    chipHospitality: "Hospitality",
    chipHealth: "Health",
    chipFinance: "Finance",
    chipEducation: "Education",
    chipRemote: "Remote",
    filters: "Filters",
    clearAll: "Clear",
    pageIndicator: "Page {page} of {total}",
    prevPage: "Previous page",
    nextPage: "Next page",
    loading: "Loading...",
    filterPanelTitle: "Filter Companies",
    countryLabel: "Country",
    allCountries: "All countries",
    regionLabel: "Region / State",
    allRegions: "All regions",
    industryLabel: "Industry",
    sizeLabel: "Company Size",
    anySize: "Any size",
    minJobsLabel: "Min. Open Roles",
    minJobsPlaceholder: "e.g. 3",
    applyFilters: "Apply Filters",
    sortMostJobs: "Most open roles",
    sortNewest: "Newest companies",
    sortAZ: "A–Z",
    sizeStartup: "Startup (1–10)",
    sizeSmall: "Small (11–50)",
    sizeMedium: "Medium (51–200)",
    sizeEnterprise: "Enterprise (1000+)",
    size_1_10: "Startup (1–10)",
    size_11_50: "Small (11–50)",
    size_51_200: "Medium (51–200)",
    size_201_500: "Mid-large (201–500)",
    size_501_1000: "Large (501–1,000)",
    size_1000_plus: "Enterprise (1000+)",
    countryNames: {
      unitedStates: "United States", spain: "Spain", portugal: "Portugal", mexico: "Mexico",
      argentina: "Argentina", colombia: "Colombia", brazil: "Brazil", unitedKingdom: "United Kingdom",
      france: "France", germany: "Germany", canada: "Canada", uruguay: "Uruguay",
    },
    industryNames: {
      technology: "Technology", finance: "Finance", healthcare: "Healthcare", marketing: "Marketing",
      education: "Education", legal: "Legal", operations: "Operations", engineering: "Engineering",
      retail: "Retail", media: "Media", realEstate: "Real Estate", hospitality: "Hospitality",
    },
  },
  companyProfile: {
    back: "Back to companies",
    opportunities: "Opportunities",
    openPositions: "Open Positions",
    about: "About",
    companyInfo: "Company Info",
    industryLabel: "Industry",
    sizeLabel: "Size",
    hqLabel: "HQ",
    getDirections: "Get Directions",
    activeJobsLabel: "Active Jobs",
    visitWebsite: "Visit Website",
    lookingForJob: "Looking for a job?",
    browseAll: "Browse all jobs",
    employees: "employees",
    openRolesLabel: "Open Roles",
    teamSize: "Team Size",
    locationLabel: "Location",
    noJobs: "No open positions right now",
    noJobsDesc: "Check back soon or browse other companies",
    websiteLabel: "Website",
    companyFallback: "Company",
    browseAllDesc: "Explore the {count} open positions at {name}.",
    foundedLabel: "Founded in",
    benefitsLabel: "Benefits",
    cultureLabel: "Culture & environment",
  },
  auth: {
    signIn: "Sign In",
    register: "Register",
    emailLabel: "Email",
    passwordLabel: "Password",
    fullNameLabel: "Full Name",
    jobSeeker: "Job Seeker",
    employer: "Employer",
    continueGoogle: "Continue with Google",
    orEmail: "or continue with email",
    createAccount: "Create Account",
    alreadyHave: "Already have an account?",
    noAccount: "Don't have an account?",
    welcomeBack: "Welcome back! Sign in to continue.",
    joinUs: "Create your account and start your journey.",
    iAm: "I am a:",
    cancel: "Cancel",
    signInAs: "Sign in as:",
    signInCandidate: "Job Seeker / Candidate",
    signInEmployer: "Employer / Company",
    namePlaceholder: "John Doe",
    emailPlaceholder: "you@example.com",
    passwordPlaceholder: "••••••••",
    passwordMinLength: "Minimum 8 characters",
    acceptTermsPrefix: "I agree to the",
    acceptTermsAnd: "and the",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    marketingOptIn: "I want to receive news and opportunities from InfoCityJobs",
    forgotPassword: "Forgot your password?",
    forgotPasswordSubtitle: "Enter your email and we'll send you a link to reset it.",
    sendResetLink: "Send instructions",
    resetEmailSent: "If an account exists for that email, you'll receive instructions to reset your password.",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    resetPassword: "Reset password",
    passwordUpdated: "Your password has been updated successfully.",
    invalidToken: "This link is invalid or has already been used.",
    expiredToken: "This link has expired. Please request a new one.",
    passwordMismatch: "Passwords do not match.",
    passwordTooShort: "Password must be at least 8 characters.",
    backToLogin: "Back to sign in",
    requestNewLink: "Request a new link",
    goToLogin: "Sign in",
  },
  userDash: {
    welcome: "Welcome back",
    applications: "Applications",
    savedJobs: "Saved Jobs",
    profile: "Profile",
    editProfile: "Edit",
    noApplications: "No applications yet",
    noApplicationsDesc: "Start applying to your dream jobs",
    browseJobs: "Browse Jobs",
    noSavedJobs: "No saved jobs",
    noSavedJobsDesc: "Save jobs you're interested in to review them later",
    findJobs: "Find Jobs",
    myApplications: "My Applications",
    applied: "Applied",
    saveChanges: "Save Changes",
    cancel: "Cancel",
    fullNameLabel: "Full Name",
    phoneLabel: "Phone",
    locationLabel: "Location",
    linkedinLabel: "LinkedIn",
    bioLabel: "Bio",
    bioPlaceholder: "Tell employers about yourself...",
    memberSince: "Member since",
    stats: "stats",
    savedLabel: "saved",
    newMatches: "New Matches",
    recommendedTitle: "Recommended Jobs For You",
    createCvBetterMatches: "Create CV for better matches",
    unlockTitle: "Unlock AI Job Matching",
    unlockDesc: "Create your CV to get personalized job recommendations with compatibility scores up to 99%.",
    getStarted: "Get Started",
    noRecsTitle: "No recommendations yet",
    noRecsDesc: "Add a CV to get personalized job recommendations",
    editCV: "Edit CV",
    createCV: "Create CV",
    noCvYetTitle: "No CV yet",
    noCvYetDesc: "Create a professional CV with AI assistance",
    createCvWithAI: "Create CV with AI",
    positionsSuffix: "positions",
    listedSuffix: "listed",
    lastUpdated: "Last updated",
    topSkills: "Top Skills",
    networkLabel: "InfoCity Network",
    percentComplete: "complete",
    addMoreInfo: "— add more info to improve your visibility",
    newJobSingular: "new job",
    newJobPlural: "new jobs",
    matchProfileDesc: "match your profile with 80%+ compatibility",
    viewOffer: "View offer",
    offerBanner_pending: "Offer received",
    offerBanner_accepted: "Offer accepted",
    offerBanner_rejected: "Offer rejected",
    offerBanner_withdrawn: "Offer withdrawn",
  },
  stages: {
    new_applicant: "Applied",
    contacted: "Contacted",
    interview: "Interview",
    offer: "Offer",
    hired: "Hired",
    rejected: "Rejected",
  },
  companyDash: {
    employerDash: "Employer Dashboard",
    overview: "Overview",
    exploreNearby: "Explore jobs near me",
    postJob: "Post a Job",
    myListings: "My Listings",
    applicants: "Applicants",
    companyProfile: "Company Profile",
    activeJobs: "Active Jobs",
    totalApplications: "Applications",
    interviews: "Interviews",
    hired: "Hired",
    recruitmentFunnel: "Recruitment Funnel",
    hiringPipeline: "Hiring Pipeline",
    listings: "Listings",
    viewAll: "View all",
    recentActivity: "Recent Activity",
    latestApps: "Latest Applications",
    noJobs: "No jobs posted yet",
    noJobsDesc: "Post your first job to start receiving candidates",
    postFirstJob: "Post Your First Job",
    noApplicants: "No applicants yet",
    noApplicantsDesc: "Applications will appear here once candidates apply",
    management: "Management",
    newListing: "New Listing",
    publishJob: "Publish Job Listing",
    editProfile: "Edit Profile",
    saveProfile: "Save Profile",
    keepUpToDate: "Keep your profile up to date to attract better candidates.",
    newJob: "New Job",
    applicantsCount: "applicants",
    viewsCount: "views",
    postedOn: "Posted",
    closeJobConfirm: "Close this job posting?",
    settings: "Settings",
    viewJob: "View job",
  },
  postJobForm: {
    titleLabel: "Job Title",
    titlePlaceholder: "e.g. Senior Software Engineer",
    locationLabel: "Location",
    locationPlaceholder: "e.g. New York, NY",
    categoryLabel: "Category",
    jobTypeLabel: "Job Type",
    experienceLabel: "Experience Level",
    salaryMin: "Salary Min (USD)",
    salaryMax: "Salary Max (USD)",
    descriptionLabel: "Job Description",
    descriptionPlaceholder: "Describe the role, responsibilities, and your ideal candidate...",
    requirementsLabel: "Requirements",
    benefitsLabel: "Benefits",
    externalLinkLabel: "External Apply Link (optional)",
    externalLinkPlaceholder: "https://company.com/careers/apply",
    addRequirement: "+ Add requirement",
    addBenefit: "+ Add benefit",
    isRemote: "This is a remote position",
    publish: "Publish Job Listing",
    successMsg: "Job posted! Redirecting...",
    companyNameLabel: "Company Name",
    websiteLabel: "Website",
    industryLabel: "Industry",
    companySizeLabel: "Company Size",
    headquartersLabel: "Headquarters",
    logoUrlLabel: "Logo URL",
    descriptionLabel2: "Description",
  },
  pipeline: {
    new_applicant: "New",
    contacted: "Contacted",
    interview: "Interview",
    offer: "Offer",
    hired: "Hired",
    rejected: "Rejected",
  },
  cvViewer: {
    loadError: "We couldn't load the CV. Please try again.",
    noPreview: "This file can't be previewed. Download it to open it.",
    back: "Back",
    downloadPdf: "Download PDF",
  },
  notifyApplicant: {
    title: "Want to notify {name}?",
    message: "Message",
    date: "Date",
    time: "Time",
    endTime: "End time",
    endTimeOptional: "End time (optional)",
    timezone: "Time zone",
    notes: "Notes / instructions for the candidate",
    modality: "Format",
    modality_in_person: "In person",
    modality_video: "Video call",
    modality_phone: "Phone call",
    modality_other: "Other",
    location: "Location",
    locationPlaceholder: "Interview address",
    link: "Video call link",
    contactName: "Contact person",
    contactRole: "Contact role",
    contactRolePlaceholder: "e.g. Hiring Manager",
    skip: "Don't notify",
    send: "Send notice",
    sendError: "We couldn't send the notice. Please try again.",
    sentToast: "Notice sent to the candidate",
    rescheduledMessage: "Your interview details were updated. Please check the new date and time.",
    template: {
      contacted: "Hi {name}, we saw your application for {job} and would like to get in touch.",
      interview: "Hi {name}, we'd like to invite you to an interview for the {job} position.",
      offer: "Hi {name}, we have an offer for you for the {job} position!",
      hired: "Hi {name}, congratulations! You've been selected for the {job} position.",
      rejected: "Hi {name}, thank you for your interest in {job}. We've decided to move forward with another candidate, but we really appreciate your application.",
    },
  },
  interviewForm: {
    sectionWhen: "WHEN",
    sectionContact: "CONTACT",
    sectionMessage: "MESSAGE FOR THE CANDIDATE",
    messagePlaceholder: "Add extra information for the candidate...",
    linkPlaceholder: "Google Meet, Zoom, Teams...",
    phonePlaceholder: "Contact number",
    otherDetailsPlaceholder: "Describe what the interview will be like",
    cancel: "Cancel",
  },
  notificationsInbox: {
    bannerLabel: "Updates on your applications",
  },
  companyBilling: {
    title: "Plan & Billing",
    trialActive: "Free trial",
    planActive: "Active plan",
    changePlan: "Change plan",
    price: "Price",
    expiresAt: "Expires",
    accessUntil: "Access until",
    noExpiry: "No expiry",
    listings: "Job listings",
    unlimited: "Unlimited",
    noActivePlan: "You don't have an active plan right now.",
    manageBilling: "Manage billing",
    portalError: "Couldn't open the billing portal. Try again.",
    paymentSuccessToast: "Payment confirmed! Your plan is being activated.",
    paymentCancelledToast: "Payment cancelled. You weren't charged.",
    pastDueWarning: "There's a problem with your payment method.",
    pastDueCta: "Update payment method",
    statusPastDue: "Payment pending",
    statusCancelling: "Cancellation scheduled",
  },
  footer: {
    description: "The professional job marketplace connecting candidates and companies: create your professional profile, prepare your CV, search for jobs, and apply to new opportunities.",
    network: "InfoCity Network",
    seekersTitle: "For Job Seekers",
    employersTitle: "For Employers",
    companyTitle: "InfoCity",
    browseJobs: "Browse Jobs",
    companies: "Companies",
    savedJobs: "Saved Jobs",
    myApplications: "My Applications",
    exploreNearby: "Explore jobs near me",
    postJob: "Post a Job",
    employerDash: "Employer Dashboard",
    hiringSolutions: "Hiring Solutions",
    applicantTracking: "Applicant Tracking",
    aboutInfoCity: "About InfoCity",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    contact: "Contact Us",
    cookiePrefs: "Cookie preferences",
    copyright: "InfoCity Ecosystem. All rights reserved.",
    partOf: "Part of the marketplace ecosystem",
  },
  legal: {
    backHome: "Back to home",
    draftDisclaimer: "This document is an operational draft and does not constitute final legal advice.",
    contactTitle: "Contact",
    contactSubtitle: "Have a question about your account, your data, or these Terms? Get in touch.",
    legalDataPending: "The responsible entity's legal data (company name, address, tax ID) is still pending.",
  },
  cookies: {
    bannerText: "We use necessary cookies for the site to work and, with your consent, analytics cookies to improve the experience.",
    learnMore: "Learn more",
    necessary: "Necessary (always on)",
    analytics: "Analytics",
    preferences: "Cookie preferences",
    savePreferences: "Save preferences",
    reject: "Reject",
    accept: "Accept",
  },
  privacy: {
    title: "Privacy and data",
    exportData: "Download my data",
    exportDataHint: "Get a JSON copy of your personal information.",
    marketingEmails: "News and opportunities by email",
    marketingEmailsHint: "You can turn this off anytime. It doesn't affect transactional emails.",
    changePasswordTitle: "Change password",
    changePasswordHint: "Changing it will log out any other devices/sessions.",
    currentPasswordLabel: "Current password",
    currentPasswordIncorrect: "Current password is incorrect.",
    changePasswordButton: "Update password",
    passwordChangedSuccess: "Your password was updated. Other sessions were logged out for security.",
    deleteAccount: "Delete my account",
    deleteWarning: "This action is irreversible. Your personal data, CV, and profile photo will be deleted. Your applications will be kept anonymized as a record for the relevant companies.",
    deleteConfirmWord: "delete",
    incorrectPassword: "Incorrect password.",
    deleteFailed: "We couldn't delete your account. Please try again.",
  },
  emailVerify: {
    title: "Verify your email",
    body: "We sent you a verification link. You can keep using InfoCityJobs in the meantime.",
    resend: "Resend email",
    resendSuccess: "We sent you a new verification email.",
    dismiss: "Not now",
    verifyingTitle: "Verifying your email...",
    successTitle: "Email verified!",
    successBody: "Your account has been confirmed successfully.",
    invalidLink: "This verification link is invalid or has already been used.",
    expiredLink: "This verification link has expired. You can request a new one from your account.",
    goToApp: "Go to InfoCityJobs",
  },
  common: {
    cancel: "Cancel",
    loading: "Loading...",
  },
  ai: {
    title: "InfoCity AI",
    subtitle: "Job Search Assistant",
    placeholder: "Ask about jobs...",
    initialMessage: "Hi! I'm the InfoCity AI Assistant. I can help you search for jobs, prepare for interviews, or guide you through the platform. What are you looking for today?",
    suggestions: ["Find tech jobs", "How to apply?", "Resume tips"],
    close: "Close",
    send: "Send",
    error: "Sorry, I'm having trouble connecting. Please try again.",
    careerTitle: "AI Career Assistant",
    careerSubtitle: "Personalized career guidance",
    careerGreeting: "Hi {name}! I'm your AI Career Assistant. I can analyze your CV, suggest matching jobs, and help you advance your career. What would you like to know?",
    careerGreetingGeneric: "Hi! I'm your AI Career Assistant. I can analyze your CV, suggest matching jobs, and help you advance your career. What would you like to know?",
    usingCvHint: "Using your CV profile for personalized answers",
    usingCompanyHint: "Using your company's data for personalized answers",
    switchToChat: "Switch to general chat",
    switchToCareer: "Switch to career mode",
    careerModeBtn: "Career",
    chatModeBtn: "Chat",
    careerPlaceholder: "Ask about your career...",
    careerSuggestions: ["What jobs match my profile?", "How can I improve my CV?", "Help me prepare for interviews"],
    // Role-aware copy (candidate / employer / guest) — used by AIChat.jsx
    subtitleCandidate: "Your job assistant",
    subtitleEmployer: "Assistant for employers",
    subtitleGuest: "Your InfoCityJobs assistant",
    greetingCandidate: "Hi {name}! I'm your InfoCityJobs career assistant. I can help you find opportunities, improve your profile and CV, prepare for interviews, and manage your job search. How can I help?",
    greetingCandidateGeneric: "Hi! I'm your InfoCityJobs career assistant. I can help you find opportunities, improve your profile and CV, prepare for interviews, and manage your job search. How can I help?",
    greetingEmployer: "Hi {name}! I'm your InfoCityJobs hiring assistant. I can help you write better job posts, find candidates, review profiles, organize interviews, and manage your hiring process. What do you need?",
    greetingEmployerGeneric: "Hi! I'm your InfoCityJobs hiring assistant. I can help you write better job posts, find candidates, review profiles, organize interviews, and manage your hiring process. What do you need?",
    greetingGuest: "Hi! I'm the InfoCityJobs assistant. I can help you find jobs, learn how the platform works, or explain how to post a job.",
    suggestionsCandidate: ["Find jobs", "Improve my CV", "Prepare for an interview", "Improve my profile"],
    suggestionsEmployer: ["Create a job post", "Find candidates", "Improve a job post", "Manage interviews"],
    suggestionsGuest: ["Find jobs", "I'm a candidate", "I'm a company", "How InfoCityJobs works"],
    placeholderCandidate: "Ask about your career...",
    placeholderEmployer: "Ask about your hiring...",
    placeholderGuest: "Ask about InfoCityJobs...",
    viewJobBtn: "View job",
    viewProfileBtn: "View profile",
    saveBtn: "Save",
    unsaveBtn: "Remove",
    compatibleLabel: "match",
    resultsRemote: "Remote",
  },
  ecosystem: {
    youAreHere: "You are here",
    prop: "Real Estate",
    jobs: "Jobs",
    cars: "Cars",
    shop: "Shopping",
    boat: "Boats",
    travel: "Travel",
  },
  errors: {
    emailTaken: "Email already registered", invalidCredentials: "Invalid email or password",
    notAuthenticated: "Not authenticated", onlyCandidates: "Only candidates can apply",
    onlyEmployers: "Only employers can post jobs", alreadyApplied: "Already applied for this job",
    jobNotFound: "Job not found", cvNotFound: "CV not found",
    aiNotConfigured: "AI service not available", parseFailed: "Could not parse CV. Try DOCX format.",
    sessionExpired: "Session expired. Please sign in again.", unknownError: "An unexpected error occurred. Please try again.",
    accountSuspended: "Your account has been suspended. Contact support for more information.",
    googleLoginFailed: "We couldn't verify your Google account. Please try again.",
    googleEmailNotVerified: "Your Google email isn't verified. Verify it in your Google account and try again.",
    noFile: "Select a file first", fileTooLarge: "File is too large",
    jobClosed: "This job is no longer accepting applications", cvVersionNotFound: "That CV version no longer exists",
  },
  company: {
    dashTitle: "Employer Dashboard", overviewLabel: "Overview", pipelineTitle: "Hiring Pipeline",
    funnel: "Recruitment Funnel", hiringPipeline: "Hiring Pipeline", activeJobs: "Active Jobs",
    totalApps: "Applications", interviews: "Interviews", hired: "Hired",
    recentActivity: "Recent Activity", latestApps: "Latest Applications",
    activeListings: "Active Listings", viewAll: "View all",
    noJobsYet: "No jobs posted yet", postFirstJob: "Post your first job to start receiving candidates",
    noApplicants: "No applicants yet", appsAppearHere: "Applications will appear here",
    interviewScheduledTitle: "Interview scheduled",
    editInterviewBtn: "Edit interview",
    editInterviewTitle: "Edit interview",
    scheduleInterviewTitle: "Schedule interview",
    scheduleInterviewBtn: "Schedule interview",
    saveInterviewChanges: "Save changes",
    editCompany: "Edit Profile", saveCompany: "Save Profile", keepUpdated: "Keep your profile up to date to attract better candidates.",
    companyName: "Company Name", website: "Website", industry: "Industry", size: "Company Size",
    hq: "Headquarters", address: "Exact address", addressPlaceholder: "Type an address and pick a suggestion",
    addressHint: "An exact address enables the \"Get Directions\" button on the public profile.",
    legalName: "Legal name", taxId: "Tax ID (NIF/CIF/EIN)", phone: "Phone",
    verificationNeedsReviewTitle: "Verification under review",
    verificationNeedsReviewDesc: "We found something to review in your details. Our team will check it; you can keep publishing jobs meanwhile.",
    verificationPendingTitle: "Complete your company's basic verification",
    verificationPendingDesc: "Add legal name, tax ID and phone to get the Basic Verification badge. It's automatic and never blocks publishing jobs.",
    verificationVerifiedDesc: "Format and consistency automatically validated.",
    logoUrl: "Logo URL", description: "Description",
    sizePlaceholder: "Select a range", sizeHelp: "Approximate number of employees",
    size_1_10: "1–10 employees", size_11_50: "11–50 employees", size_51_200: "51–200 employees",
    size_201_500: "201–500 employees", size_501_1000: "501–1,000 employees", size_1000_plus: "More than 1,000 employees",
    changeLogo: "Change logo", removeLogo: "Remove logo", removeLogoConfirm: "Remove the company logo?",
    saveLogo: "Save logo", logoInvalidType: "Invalid format. Use JPEG, PNG or WEBP.",
    logoTooLarge: "The image is too large (max 8MB).", logoSavedOk: "Logo updated", logoRemovedOk: "Logo removed",
    logoUploadError: "Couldn't update the logo. Please try again.",
    settings: "Settings", viewJob: "View job", closeJob: "Close this job posting?",
    applicants: "applicants", views: "views", postedOn: "Posted",
    viewCv: "View CV", primaryCvSubmitted: "Primary CV", adaptedCvSubmitted: "CV tailored for this job",
    postFirstJobBtn: "Post Your First Job",
    pauseTooltip: "Pause job", resumeTooltip: "Reactivate job", closeTooltip: "Close job", editTooltip: "Edit job",
    topMatchingCandidates: "Top Matching Candidates", allApplicantsTitle: "All Applicants",
    jobPositionLabel: "Job Position", allJobsOption: "All Jobs",
    searchCandidatesLabel: "Search Candidates", searchCandidatesPlaceholder: "Search by name, skill, keyword...",
    rankedByAI: "Ranked by AI match score",
    linkedinProfileLink: "LinkedIn Profile", profileLink: "Profile", noCvUploaded: "No CV uploaded",
    cancelBtn: "Cancel",
    noCompanyProfileYet: "You haven't set up your company profile yet. Click \"Edit Profile\" to get started.",
    profileCompleteness: "Profile {pct}% complete",
    foundedYear: "Founded year",
    linkedinUrl: "LinkedIn",
    instagramUrl: "Instagram",
    culture: "Culture & environment",
    culturePlaceholder: "Tell us what it's like to work at your company...",
    benefits: "Benefits",
    benefitsPlaceholder: "One benefit per line, e.g: Flexible hours",
    benefitsHint: "Write one benefit per line.",
    searchListingsPlaceholder: "Search by title...",
    filterAll: "All",
    sortNewest: "Newest",
    sortOldest: "Oldest",
    sortApplicants: "Most applicants",
    noListingsMatch: "No listings match those filters.",
    postErrorGeneric: "Could not post the job. Please try again.",
    editErrorGeneric: "Could not update the job. Please try again.",
    stageErrorGeneric: "Could not update the candidate's stage. Please try again.",
    profileSaveError: "Could not save the company profile. Please try again.",
    profileSavedOk: "Profile saved successfully", jobUpdatedOk: "Job updated successfully",
    stageUpdatedOk: "Candidate stage updated",
    locationNotVerifiedWarning: "We couldn't verify this location on the map. The job will still be published, but please double-check the address.",
    salaryRangeError: "Minimum salary cannot be greater than maximum salary.",
    locationRequiredError: "Select the job's country and city.",
    requirementPlaceholder: "Requirement",
    titlePlaceholder: "e.g. Senior Software Engineer", locationPlaceholder: "e.g. New York, NY",
    descriptionPlaceholder: "Describe the role, responsibilities, and your ideal candidate...",
    matchHigh: "High", matchMedium: "Medium", matchLow: "Low",
    matchSuffix: "match",
    topCandidatesEyebrow: "Match", topCandidatesTitle: "Top candidates",
    noCandidatesYet: "You don't have candidates to compare yet.", forJobLabel: "For:",
    kpiActiveJobs: "Active jobs", kpiNewCandidates: "New candidates",
    kpiUpcomingInterviews: "Upcoming interviews", kpiHires: "Hires",
    kpiLast7Days: "Last 7 days", kpiLast30Days: "Last 30 days",
    interviewsEyebrow: "Schedule", upcomingInterviewsTitle: "Upcoming interviews",
    interviewsUpcomingTab: "Upcoming", interviewsHistoryTab: "History",
    noUpcomingInterviews: "You have no upcoming interviews.",
    noInterviewHistory: "You have no past interviews yet.",
    viewCandidateBtn: "View candidate",
    stageFilterAll: "All", sortByLabel: "Sort by",
    sortRecent: "Most recent", sortMatchDesc: "Highest match", sortMatchAsc: "Lowest match",
    viewMatchAnalysisBtn: "See why",
    viewInterviewDetailsBtn: "View details",
    changeStageAria: "Change stage",
    changeStageBtn: "Change stage",
    candidateProfileAction: "Profile",
    candidateMessageAction: "Message",
    offerStatus_pending: "Offer pending",
    offerStatus_accepted: "Offer accepted",
    offerStatus_rejected: "Offer rejected",
    offerStatus_withdrawn: "Offer withdrawn",
    offerWithdrawBtn: "Withdraw offer",
    offerWithdrawConfirm: "Withdraw this offer?",
    offerWithdrawnOk: "Offer withdrawn",
    confirmHireBtn: "Confirm hire",
    confirmHireMsg: "Confirm hiring {name} for {job}?",
  },
  offerModal: {
    title: "Create job offer",
    previewTitle: "Offer preview",
    previewSubtitle: "Review the details before sending",
    jobTitle: "Role",
    workMode: "Work mode",
    compMin: "Compensation",
    compMax: "Max amount",
    currency: "Currency",
    period: "Period",
    period_hour: "per hour", period_day: "per day", period_week: "per week", period_month: "per month", period_year: "per year",
    compDetails: "Compensation details",
    compDetailsPlaceholder: "E.g.: plus tips, performance bonus...",
    employmentType: "Employment type",
    schedule: "Schedule",
    startDate: "Expected start date",
    location: "Location",
    additionalDetails: "Additional details / conditions",
    company: "Company",
    cancel: "Cancel",
    continue: "Continue",
    send: "Send offer",
    sendError: "Couldn't send the offer. Please try again.",
    sentToast: "Offer sent",
  },
  offerDetail: {
    title: "Offer received",
    status_accepted: "Offer accepted",
    status_rejected: "Offer rejected",
    status_withdrawn: "This offer was withdrawn by the company",
    accept: "Accept offer",
    reject: "Reject offer",
    confirmAccept: "Confirm you want to accept this offer from {company} for {job}?",
    confirmReject: "Confirm you want to reject this offer from {company} for {job}?",
    rejectReasonPrompt: "Reason for rejecting (optional)",
    actionError: "Couldn't process the action. Please try again.",
  },
  categories: {
    Technology: "Technology / IT", Finance: "Banking / Finance", Marketing: "Marketing / Advertising", Design: "Design / Creative",
    Healthcare: "Medicine / Healthcare", Education: "Education", Sales: "Sales", Operations: "Operations",
    Product: "Product", Legal: "Legal", Hospitality: "Hospitality", Logistics: "Logistics / Transport",
    Administration: "Administration", CustomerService: "Customer Service", Construction: "Construction",
    Accounting: "Accounting", FoodService: "Food Service / Restaurants", Tourism: "Hospitality / Tourism",
    Engineering: "Engineering", SkilledTrades: "Skilled Trades / Maintenance", Manufacturing: "Manufacturing / Production",
    HumanResources: "Human Resources", Retail: "Retail / Commerce", Security: "Security", Services: "Services",
    Other: "Other",
  },
  companyVisibility: {
    question: "How do you want to show the company on this listing?",
    showCompany: "Show my company",
    hideCompany: "Post as a confidential company",
    chooseDisplayLabel: "What do you want to show instead?",
    previewTitle: "This is how your listing will appear",
    hiddenNotice: "Your real name will NOT be publicly visible on this listing.",
    presetOther: "Other",
    presetOtherPlaceholder: "Write how you want it to appear",
    presetOtherExample: "E.g: Leading company in the hospitality sector",
    preset_important: "Leading company",
    preset_important_sector: "Leading company in the {sector} sector",
    preset_important_sector_generic: "Leading company in the sector",
    preset_leader_sector: "Sector-leading company in {sector}",
    preset_leader_sector_generic: "Sector-leading company",
    preset_recognized: "Well-known company in the {sector} sector",
    preset_recognized_generic: "Well-known company",
    preset_international: "International company",
    preset_multinational: "Multinational company",
    preset_growing: "Growing company",
    preset_startup: "Growing startup",
    preset_group: "Business group",
    preset_consultancy: "Specialized consultancy",
  },
  companyAccess: {
    title: "Choose the ideal plan for your company",
    subtitle: "Publish your jobs and start receiving candidates.",
    limitTitle: "You've reached your plan's listing limit",
    limitSubtitle: "Choose another plan with more listings included or wait for your next renewal.",
    noPlansAvailable: "Plans for your country will be available soon. Contact the InfoCityJobs team.",
    choosePlan: "Choose plan",
    continueToPayment: "Continue to payment",
    startTrial: "Start free trial",
    days: "days",
    listingsIncluded: "listings included",
    formPreservedNote: "Your listing was saved exactly as you left it — nothing was lost.",
    activatedToast: "Plan activated. You can now publish your job.",
    trialStartedToast: "Trial started. You can now publish your job.",
    alreadySubscribedNote: "You already have an active subscription. Manage your plan, payment method or cancellation from Manage Billing.",
    durationUnit: { day: "day", week: "week", month: "month", year: "year", unlimited: "no expiration" },
  },
  jobDetailExtra: {
    applyPosition: "Apply for Position", at: "at", fullNameReq: "Full Name *", emailReq: "Email *",
    phoneReq: "Phone *", linkedinOpt: "LinkedIn (optional)", uploadCV: "Upload CV",
    uploadHint: "Click to upload PDF, DOC, DOCX", coverLetter: "Cover Letter",
    coverHint: "Why are you a great fit?", submitApp: "Submit Application",
    successTitle: "Application Submitted!", successMsg: "Good luck! The team will be in touch.",
    continue: "Continue Browsing", closeModal: "Close",
    selectCvTitle: "Which CV do you want to apply with?", primaryCvLabel: "Primary CV",
    recommendedBadge: "Recommended for this job", adaptCvSecondaryCta: "Adapt my CV to this job",
    noCvTitle: "You need a CV to apply", noCvDesc: "Create your professional CV to be able to send applications.",
    createCvCta: "Create my CV", versionDeletedError: "That CV version no longer exists. Choose another option.",
    usedCvLabel: "CV used", viewApplicationsCta: "View my applications",
  },
  profProfile: {
    back: "Back", openToWorkBadge: "✓ Open to Work", summary: "Professional Summary",
    workExp: "Work Experience", education: "Education", skills: "Skills", languages: "Languages",
    certifications: "Certifications", portalCompat: "Portal Compatibility", activeIn: "Active in",
    editProfile: "Edit Profile", downloadCV: "Download CV", completeness: "Profile Completeness",
    completePrompt: "Complete profile →", present: "Present",
  },
  lang: { es: "Español", en: "English", pt: "Português" },

  tabs: {
    recommended: "Recommended", applications: "Applications", savedJobs: "Saved Jobs",
    myCV: "My CV", professionalProfile: "Professional Profile", overview: "Overview",
    exploreNearby: "Explore jobs near me",
    postJob: "Post a Job", myListings: "My Listings", applicants: "Applicants", companyProfile: "Company Profile",
  },
  hiring: {
    pipelineTitle: "Hiring Pipeline", pipelineFunnel: "Recruitment Funnel", topCandidates: "Top Matching Candidates",
    allApplicants: "All Applicants", hiringProbability: "Hiring Probability",
    high: "High", medium: "Medium", low: "Low", rankedByAI: "Ranked by AI match score",
    filterByJob: "Job Position", allJobs: "All Jobs", searchCandidates: "Search Candidates",
    searchPlaceholder: "Search by name, skill, keyword...", viewProfile: "View Profile", viewCV: "View CV",
    noCV: "No CV uploaded", coverLetter: "Cover Letter",
  },
  cv: {
    builderTitle: "CV Builder", builderSubtitle: "Create a professional CV with AI assistance in minutes",
    aiPowered: "AI Powered", stepPersonal: "Personal Info", stepSummary: "Summary",
    stepExperience: "Experience", stepEducation: "Education", stepSkills: "Skills",
    stepLanguages: "Languages", stepPreview: "Preview & Save", fullName: "Full Name",
    professionalTitle: "Professional Title", yearsExp: "Years of Experience",
    titlePlaceholder: "e.g. Senior Software Engineer",
    summaryHint: "Write your background and let AI improve it automatically.",
    generateAI: "Generate with AI", aiImprove: "AI Improve", suggestSkills: "Suggest Skills with AI",
    uploadCVBtn: "Upload PDF / DOCX", importCVHint: "Already have a CV? Import it automatically",
    parsing: "Parsing...", parsedOK: "CV parsed and imported", parseFailed: "Failed to parse. Try DOCX format.",
    aiImproved: "AI improved your text!", addTextFirst: "Add some text first",
    company: "Company", position: "Position", startDate: "Start Date", endDate: "End Date",
    currentJob: "Current", responsibilities: "Responsibilities", institution: "Institution",
    degree: "Degree", field: "Field of Study", year: "Year",
    skillsHint: "Type a skill and press Enter", industriesHint: "e.g. Technology, Finance...",
    languagesHint: "e.g. English (Native), Spanish (B2)...", certHint: "e.g. AWS, PMP, Google Analytics...",
    industries: "Industries", addExperience: "+ Add Experience", addEducation: "+ Add Education",
    saveCV: "Save CV", saving: "Saving...", saved: "CV saved", downloadPDF: "Download PDF",
    downloadWord: "Download Word", goToDashboard: "Go to Dashboard", toDashboard: "View Dashboard",
    cvStrength: "CV Strength", cvScore: "CV Score", suggestions: "Suggestions",
    previous: "Previous", next: "Next", previewTitle: "Preview & Save",
    skillsFieldLabel: "Skills (press Enter to add)", languagesFieldLabel: "Languages (press Enter to add)",
    certFieldLabel: "Certifications (press Enter to add)",
    certDetailHint: "You can add organization, dates and credential from your Professional Profile.",
    summaryPlaceholder: "Experienced software engineer with 5+ years building scalable web applications...",
    companyPlaceholder: "e.g. TechCorp Inc.", positionPlaceholder: "e.g. Senior Engineer",
    responsibilitiesPlaceholder: "Describe your main responsibilities and achievements...",
    institutionPlaceholder: "e.g. MIT", degreePlaceholder: "e.g. Bachelor's", fieldPlaceholder: "e.g. Computer Science",
    stepCounterPrefix: "Step", stepCounterOf: "of", viewStages: "View stages",
    saveHint: "Press \"Save CV\" to finish and download your resume.",
  },
  bottomNav: {
    search: "Search", recommended: "Recommended", applications: "Applications", myJobs: "My Jobs", messages: "Messages", whoViewedMe: "Who Viewed Me", cv: "CV", profile: "Profile", home: "Home",
    overview: "Overview", listings: "Listings", post: "Post", applicants: "Applicants", panel: "My Panel",
  },
  mobileHeader: { menu: "Menu", notifications: "Notifications", settings: "Settings", myProfile: "My profile", guestSubtitle: "Find your next job", hiringCta: "Hiring?", sectionAccount: "Account", sectionExplore: "Explore", sectionHelp: "Help", help: "Help" },
  myJobs: {
    title: "My Jobs",
    tabSaved: "Saved", tabApplications: "Applied", tabInterviews: "Interviews",
    savedEmptyTitle: "You haven't saved any jobs yet",
    savedEmptyDesc: "Save jobs you're interested in to find them easily here.",
    savedCta: "Search jobs",
    appsEmptyTitle: "You haven't applied to any jobs yet",
    appsEmptyDesc: "Once you apply to a job, you can track its status here.",
    interviewsEmptyTitle: "No interviews scheduled",
    interviewsEmptyDesc: "When a company schedules an interview, it will appear here.",
    interviewsUpcomingTab: "Upcoming", interviewsHistoryTab: "History",
    interviewsHistoryEmptyTitle: "You have no past interviews yet",
    interviewsHistoryEmptyDesc: "Interviews that already happened will appear here.",
    interviewLabel: "Interview",
    withLabel: "With",
    addToCalendar: "Add to calendar",
    calendarPositionLabel: "Interview for",
    calendarCompanyLabel: "Company",
    calendarContactRoleLabel: "Contact role",
    calendarModalityLabel: "Format",
    calendarLinkLabel: "Interview link",
    calendarNotesLabel: "Notes",
    calendarFooter: "Created from InfoCityJobs",
  },
  calendarSheet: {
    title: "Add to calendar",
    googleTitle: "Google Calendar",
    googleSubtitle: "Add with Google Calendar",
    appleTitle: "Apple Calendar",
    appleSubtitle: "Add to your iPhone, iPad or Mac calendar",
    cancel: "Cancel",
  },
  whoViewedMe: {
    title: "Who Viewed Me",
    emptyTitle: "No recent views yet",
    emptyDesc: "When a company finds or visits your profile, it will appear here.",
    cta: "Improve my profile",
    relatedTo: "Related to",
  },
  profileHub: {
    companiesCanFindYou: "Companies can find you",
    onlyAppliedCompaniesCanSeeYou: "Only companies you applied to can see you",
    visibilitySaveError: "Couldn't save the change, please try again.",
    visibilityOnTitle: "Visible profile",
    visibilityOnDesc: "Every registered company can find and view your professional profile.",
    visibilityOffTitle: "Private profile",
    visibilityOffDesc: "Your profile won't show up in searches, Talent Pool, recommendations or candidate discovery. Only companies you've applied to can view it.",
    rowProfessionalProfile: "Professional profile",
    rowCV: "CV",
    rowContact: "Contact information",
    rowCountryLanguage: "Country & language",
    rowSettings: "Settings",
    rowAccount: "Account",
    rowPrivacy: "Privacy",
    rowHelp: "Help",
    logout: "Sign out",
  },
  settingsHub: {
    back: "Back",
    soundLabel: "Message sound",
    soundHint: "Plays a sound when a new message arrives.",
  },
  contact: { postalCodeLabel: "Postal code", postalCodePrivate: "Only visible to you" },
  countryLanguage: { countryLabel: "Country", languageLabel: "Language" },
  messages: {
    title: "Messages",
    emptyTitle: "No messages yet",
    emptyDesc: "When a company reaches out to you, their messages will appear here.",
    selectConversation: "Select a conversation",
    messagePlaceholder: "Write a message…",
    send: "Send",
    sendMessage: "Send message",
    sendError: "We couldn't send your message. Please try again.",
    pushBannerText: "Turn on notifications so you never miss a new message, even when InfoCityJobs is closed.",
    pushBannerEnable: "Enable notifications",
    soundOnTooltip: "Sound on — click to mute",
    soundOffTooltip: "Sound muted — click to enable",
    typingIndicator: "Typing…",
    deleteConversationConfirm: "Delete this conversation? It will only be removed from your inbox — the other side will still see it.",
    deleteConversationTooltip: "Delete conversation",
  },

  notifOnboarding: {
    title: "Turn on notifications",
    body: "Get messages, interviews, and important updates even when InfoCityJobs isn't open.",
    activate: "Enable notifications",
    notNow: "Not now",
  },
  profile: {
    universal: "InfoCity Universal Professional Profile", myProfile: "Profile",
    editProfile: "Edit Profile", viewPublic: "How Companies See Me",
    completeness: "Profile Completeness", completeProfile: "Complete profile →",
    about: "About", career: "Career", academic: "Academic", workExp: "Work Experience",
    portalCompat: "Portal Compatibility", activeIn: "Active in",
    openToWork: "Open to Work", openToWorkDesc: "Allow companies to discover your profile in the Talent Pool",
    openToWorkActive: "Your profile is visible to companies in the Talent Pool",
    addTitle: "Add your title", addLocation: "Add location", addExperience: "Add experience",
    yearsExp: "years experience", present: "Present",
  },

  /* ── Professional Profile tab (My Professional Profile) ── */
  profTab: {
    unnamedCandidate:   "Candidate",
    availableStatus:    "Available for new opportunities",
    notAvailableStatus: "Not currently available",
    privacyHint:        "Turning on \"Available for work\" makes your profile and professional information visible to companies on the platform.",
    completeProfileCta: "Complete profile",
    completeCtaBasic_info: "Complete basic info",
    completeCtaSummary: "Add summary",
    completeCtaExperience: "Add experience",
    completeCtaEducation: "Add education",
    completeCtaSkills: "Add skills",
    completeCtaLanguages: "Add languages",
    completeCtaIndustries: "Add industry",
    completeCtaPreferences: "Add job preferences",
    completeCtaCv_document: "Generate your CV",
    completeCtaPhoto: "Add photo",
    save: "Save", cancel: "Cancel", delete: "Delete", saving: "Saving...",

    basicInfoTitle: "Basic info",
    nameLabel: "Full name",
    titleFieldLabel: "Professional headline",
    titleFieldPlaceholder: "e.g. Telecommunications Technician",
    locationFieldLabel: "Location",
    phoneFieldLabel: "Phone",
    linkedinFieldLabel: "LinkedIn",

    aboutTitle: "About me",
    summaryEmpty: "Tell us about your professional background so companies get to know you better.",
    addSummaryBtn: "Add summary",
    editSummaryBtn: "Edit summary",
    improveWithAI: "Improve with AI",
    summaryPlaceholder: "Describe your experience, strengths and professional goals...",

    experienceTitle: "Work experience",
    experienceEmpty: "You haven't added any experience yet.",
    addExperienceBtn: "Add experience",
    editExperienceTitle: "Edit experience",
    addExperienceTitle: "Add experience",
    deleteExperienceConfirm: "Delete this experience?",
    positionLabel: "Position",
    companyLabel: "Company",
    startDateLabel: "Start date",
    endDateLabel: "End date",
    currentJobLabel: "I currently work here",
    experienceLocationLabel: "Location (optional)",
    descriptionLabel: "Description",

    educationTitle: "Education",
    educationEmpty: "You haven't added any education yet.",
    addEducationBtn: "Add education",
    editEducationTitle: "Edit education",
    addEducationTitle: "Add education",
    deleteEducationConfirm: "Delete this education entry?",
    institutionLabel: "Institution",
    degreeLabel: "Degree",
    fieldLabel: "Field of study",
    yearLabel: "Year",

    skillsEmpty: "Add your skills to stand out in searches.",
    addSkillBtn: "Add skill",
    editSkillsTitle: "Edit skills",
    skillsHint: "Type a skill and press Enter",
    showAllSkills: "Show all ({count})",
    showLessSkills: "Show less",

    languagesEmpty: "Add the languages you speak.",
    addLanguageBtn: "Add language",
    editLanguagesTitle: "Edit languages",
    languageNamePlaceholder: "Language (e.g. English)",
    languageLevelLabel: "Level",
    levelNative: "Native",
    levelAdvanced: "Advanced (C1)",
    levelIntermediate: "Intermediate (B2)",
    levelBasic: "Basic (A2)",
    addLanguageAction: "Add",

    preferencesTitle: "Job preferences",
    preferencesEmpty: "Tell us what kind of job you're looking for to improve your recommendations.",
    addPreferencesBtn: "Add preferences",
    editPreferencesTitle: "Job preferences",
    desiredPositionsLabel: "Desired positions",
    desiredPositionsHint: "Type a position and press Enter",
    desiredCategoriesLabel: "Professional categories",
    desiredLocationsLabel: "Desired locations",
    desiredLocationsHint: "Type a location and press Enter",
    preferredModalityLabel: "Work mode",
    preferredShiftLabel: "Shift type",
    preferredContractLabel: "Contract type",
    availabilityLabel: "Availability",
    availabilityImmediate: "Immediate",
    availability2Weeks: "In 2 weeks",
    availability1Month: "In 1 month",
    availabilityNegotiable: "Negotiable",
    salaryMinExpectationLabel: "Minimum expected salary",
    willingToRelocateLabel: "Willing to relocate",
    willingToTravelLabel: "Willing to travel",

    cvDocTitle: "CV & Documents",
    cvDocUpdated: "Updated",
    cvDocEmpty: "You haven't created your CV yet.",
    cvDocCreateBtn: "Create my CV",
    viewCvBtn: "View CV",

    missingHintBasic_info: "Complete your basic info so companies can find you.",
    missingHintSummary: "Add a professional summary to stand out.",
    missingHintExperience: "Add your work experience to improve your applications.",
    missingHintEducation: "Add your education to complete your profile.",
    missingHintSkills: "Add at least 3 skills to appear in more searches.",
    missingHintLanguages: "Add the languages you speak.",
    missingHintIndustries: "Add at least one industry to improve your recommendations.",
    missingHintPreferences: "Add your job preferences to improve your recommendations.",
    missingHintCv_document: "Generate your CV so you can apply to jobs.",
    missingHintPhoto: "Add a profile photo to make a better first impression.",

    avatarTitle: "Profile photo",
    cropAvatarTitle: "Adjust your photo",
    changePhotoBtn: "Change photo",
    deleteAvatarConfirm: "Delete your profile photo?",
    avatarInvalidType: "Invalid format. Use JPEG, PNG or WEBP.",
    avatarTooLarge: "Image is too large (max. 8MB).",

    companyViewCta: "How companies see me",
    companyPreviewNote: "This is a preview of how your professional profile can be presented to companies.",
    backToEditProfile: "Back to edit profile",

    industriesTitle: "Industries",
    industriesEmpty: "You haven't added any industries yet.",
    addIndustryBtn: "Add industry",
    editIndustriesTitle: "Edit industries",
    industriesHint: "Type an industry and press Enter",

    certificationsTitle: "Certifications",
    certificationsEmpty: "You haven't added any certifications yet.",
    addCertificationBtn: "Add certification",
    editCertificationTitle: "Edit certification",
    addCertificationTitle: "Add certification",
    deleteCertificationConfirm: "Delete this certification?",
    certNameLabel: "Certification name",
    certNameRequired: "Enter the certification name.",
    certIssuerLabel: "Issuing organization",
    certIssueDateLabel: "Issue date",
    certExpiryDateLabel: "Expiry date",
    certNoExpiryLabel: "Doesn't expire",
    certCredentialIdLabel: "Credential ID (optional)",
    certCredentialUrlLabel: "Credential URL (optional)",
    certInvalidUrl: "The credential URL is not valid.",
    viewCredentialLink: "View credential",

    savedSuccess: "Profile updated",
  },
  homeSections: {
    cvTitle: "Your CV", cvSubtitle: "Complete your profile to improve your applications.",
    cvComplete: "complete", cvStateIncomplete: "Complete your profile", createMyCV: "Create CV", continueCV: "Continue CV", viewEditCV: "View or edit CV",
    hiringQuestion: "Hiring?", postJobLink: "Post a job",
    uploadMyCV: "Upload My CV",
    freeCVBuilder: "Free CV Builder", freeCVDesc: "No cost, no credit card",
    aiImprovements: "AI Improvements", aiImprovDesc: "Auto-enhanced descriptions",
    downloadPDF: "Download PDF", downloadPDFDesc: "Professional format ready",
    talentLabel: "Talent Pool", talentTitle: "Discover top talent",
    talentSubtitle: "Browse professionals ready to work and find the right candidate for your company.",
    talentFilters: "Filters", talentLocation: "Location", talentSkills: "Skills",
    talentIndustry: "Industry", talentMinExp: "Min. Experience", talentAnyExp: "Any",
    talentApply: "Apply", talentClear: "Clear",
    talentNoResults: "No candidates found", talentNoResultsDesc: "Candidates appear here when they set their profile as \"Open to Work\"",
    talentBrowseAll: "Browse all talent", talentViewProfile: "View Profile",
    talentYearsExp: "y exp", talentFresher: "Fresher",
    talentShowing: "Showing", talentOf: "of", talentCandidates: "candidates",
    quickPostLabel: "For Employers", quickPostTitle: "Post a job in 60 seconds",
    quickPostSubtitle: "Reach thousands of qualified candidates and find the right talent faster.",
    quickPostFree: "Free to post", quickPostInstant: "Instant visibility", quickPostAI: "AI candidate matching",
    quickPostBtn: "Post Job", quickPostTitle2: "Job title (e.g. Frontend Developer)",
    quickPostLocation: "City or location (e.g. Madrid)", quickPostCompany: "Company name",
    signUpCandidate: "Sign up as a candidate →",
  },
  postJobLabels: {
    newListing: "New Listing", postJobTitle: "Post a Job", jobTitleLabel: "Job Title",
    locationLabel: "Location", currentLocationLabel: "Current location", categoryLabel: "Category", jobTypeLabel: "Job Type",
    experienceLabel: "Experience Level", salaryMinLabel: "Salary Min", salaryMaxLabel: "Salary Max",
    categoryOtherPlaceholder: "Type the category", jobTypeOtherPlaceholder: "Type the job type", experienceOtherPlaceholder: "Type the experience level",
    descriptionLabel: "Job Description", requirementsLabel: "Requirements", benefitsLabel: "Benefits",
    externalLinkLabel: "External Apply Link (optional)", isRemote: "This is a remote position",
    urgencyLabel: "Immediacy", urgencyNormal: "Normal job", urgencyToday: "Need to fill today",
    urgencyUrgent: "Urgent", shiftLabelPlaceholder: "Shift/schedule (optional, e.g. Afternoon 4-10pm)",
    addRequirement: "+ Add requirement", addBenefit: "+ Add benefit", publishBtn: "Publish Job Listing",
    successMsg: "Job posted! Redirecting...", remotePosition: "Remote position",
    management: "Management", listings: "Active Listings", newJob: "New Job",
    viewJob: "View job", applicants: "applicants", views: "views", posted: "Posted", closeJob: "Close this job posting?",
    active: "Active", paused: "Paused", closed: "Closed",
    editJobTitle: "Edit Job", updateBtn: "Save Changes", cancelEditBtn: "Cancel Edit",
    // Sprint: Post a Job improvements (salary, work mode, urgency, application, AI, preview)
    salaryPeriodLabel: "Salary period",
    periodHour: "Per hour", periodMonth: "Per month", periodYear: "Per year",
    hideSalaryLabel: "Don't show salary",
    workModeLabel: "Work mode",
    workModeOnsite: "On-site", workModeHybrid: "Hybrid", workModeRemote: "Remote",
    remoteCountriesLabel: "Which countries can the candidate work from?",
    addressLabel: "Exact address (optional)",
    addressPlaceholder: "Street and number, e.g. 123 Main Street",
    addressHint: "Only used to pinpoint the map marker precisely — never shown publicly on the listing.",
    urgencyImmediate: "Immediate start",
    applicationMethodLabel: "How will you receive applications?",
    applyMethodInternal: "Receive applications on InfoCityJobs",
    applyMethodExternal: "Redirect to an external site",
    externalLinkInvalid: "Enter a valid URL (must start with http:// or https://)",
    improveWithAI: "✨ Improve with AI",
    improvingWithAI: "Improving with AI...",
    aiImproveModalTitle: "AI-improved proposal",
    aiImproveOriginal: "Your original text",
    aiImproveProposal: "AI proposal",
    aiImproveAccept: "Use this version",
    aiImproveCancel: "Cancel",
    aiImproveError: "Couldn't improve the description. Try again.",
    aiImproveEmptyError: "Write a description before improving it with AI.",
    previewBtn: "Preview",
    backToEditBtn: "Back to edit",
    publishFinalBtn: "Publish job",
    saveChangesFinalBtn: "Save changes",
    previewSectionTitle: "This is how the candidate will see your listing",
    confidentialCompanyLabel: "Confidential company",
    previewSalaryHidden: "Salary not visible to candidates",
  },
  geo: {
    countryLabel: "Country",
    countryPlaceholder: "Select a country",
    cityLabel: "City / Locality",
    cityPlaceholder: "Start typing to search...",
    cityNoResults: "No matches found. You can still type the location manually.",
    cityHint: "Select a suggestion to verify the location on the map.",
    currencyLabel: "Currency",
    currencyPlaceholder: "Select a currency",
    locationVerifiedBadge: "Location verified",
    locationUnverifiedBadge: "Not verified on the map",
    admin1LabelByKey: {
      comunidadAutonoma: "Autonomous Community", departamento: "Department",
      estado: "State", provincia: "Province",
    },
    admin1PlaceholderByKey: {
      comunidadAutonoma: "Select an autonomous community", departamento: "Select a department",
      estado: "Select a state", provincia: "Select a province",
    },
    admin2Label: "Province",
    admin2Placeholder: "Select a province",
    anyCountry: "Any country",
    anyRegion: "Any region",
    anyProvince: "Any province",
    done: "Done",
    countryNames: { ES: "Spain", UY: "Uruguay", US: "United States", AR: "Argentina", BR: "Brazil" },
    currencyNames: { EUR: "Euro", USD: "US Dollar", UYU: "Uruguayan Peso", ARS: "Argentine Peso", BRL: "Brazilian Real" },
  },
};

export default en;

en.common = { close: "Close", seeAll: "See all" };
en.share = { intro: "Check out this job on InfoCityJobs:", linkCopied: "Link copied" };
en.cvSuggestions = {
  add_summary: "Add or expand your professional summary",
  add_more_experience: "Add more work experiences",
  add_experience: "Add at least one work experience",
  add_more_skills: "Add more relevant skills (aim for 6+)",
  add_skills: "Add technical and soft skills",
  add_education: "Add your education background",
  add_linkedin: "Add your LinkedIn profile URL",
  add_languages: "Add languages you speak",
  add_certifications: "Add professional certifications",
};
